import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { BACKEND_URL, KEY_ACCESS_TOKEN, KEY_CONFIG_URL } from '../Helpers/constant';
import { LoginData } from '../interfaces/Auth';

// export let axiosInstance: AxiosInstance;
// const configUrl = KEY_CONFIG_URL;
const turbosendURL = 'https://turbosend-impl-dev-ken-api.turboverse.co';

let appConfig: AppConfig | undefined;
const configUrl = KEY_CONFIG_URL;

interface AppConfig {
  apiBaseUrl: string;
  tokenUrl: string;
  [key: string]: any;
}

export const getAxiosInstance = (): AxiosInstance => {
  const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    if (req.headers) {
      (req.headers as Record<string, string>).Authorization = `Bearer ${token}`;
    }
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error: any) {
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }
      const config: AxiosRequestConfig = {
        method: 'get',
        baseURL: `${appConfig?.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token}`;
        return axios(error.response.config);
      });
    }
  );
  return axiosInstance;
};

export let axiosInstance: AxiosInstance = getAxiosInstance();

export const getConfig = async () => {
  try {
    const configKey = '664c2d35a926bb001ae67409';
    const res = await axios.get(`${configUrl}/${configKey}`);
    return res && res.data ? res.data : null;
  } catch (err) {
    return err;
  }
};

// export const verifyOtp = async (email: string, otp: string) => {
//   try {
//     const path = `/v1/auth/verify_otp?email=${email}&otp=${otp}`;
//     const res = await axiosInstance.get(path);
//     return res && res.data ? res.data : res;
//   } catch (error) {
//     return error;
//   }
// };

export const verifyOtpReset = async (email: string, otp: string) => {
  try {
    const path = `/v1/auth/verify/otpwithContact?email=${email}&otp=${otp}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const loginSSO = async (email: string) => {
  try {
    const path = `/v1/auth/sso/user/verify?email=${email}`;
    const response = axiosInstance.get(path);
    return response;
  } catch (error) {
    return error;
  }
};

export const authLogin = async (data: LoginData) => {
  try {
    const path = `/v1/auth/login/verify`;
    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const resetPassword = async (data: LoginData) => {
  try {
    const path = `/v1/auth/login/reset`;
    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFileUrl = async (data: File) => {
  try {
    const path = `/v1/helper/create/publicUrl`;
    const form = new FormData();
    form.append('file', data);
    const res: any = await axiosInstance.post(path, form);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getSendOTPWithoutContact = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(`/services/apexrest/portal/send`)}`;
  // const path = `salesforce?endpoint=${encodeURIComponent(`services/apexrest/signupotp/send?email=${email}&phone=${phone}&firstname=${firstname}&lastname=${lastname}`)}`;
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const getAllTVShows = async (type: any) => {
  const path = `salesforce?endpoint=services/apexrest/ideabaaz/retrieve/forms?type=P47`;
  // const path = `salesforce?endpoint=services/apexrest/ideabaaz/retrieve/forms?type=${type}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicationsByApplicantId = async (applicantid: any) => {
  const path = `salesforce?endpoint=/services/apexrest/ideabaaz/retrieve/applications?applicantid=${applicantid}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createUpdateApplication = async (data: any) => {
  const path = `salesforce?endpoint=/services/apexrest/ideabaaz/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getApplicationByApplicationId = async (applicationId: any) => {
  const path = `salesforce?endpoint=/services/apexrest/ideabaaz/retrieve/application?applicationid=${applicationId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getDocumentByDocId = async (docId: any) => {
  const path = `salesforce?endpoint=services/apexrest/ideabaaz/retrieve/document?docid=${docId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

// auth apis
export const getOtp = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(`/services/apexrest/login/send`)}`;
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const verifyOTP = async (payload: any) => {
  const path = `/salesforce?endpoint=${encodeURIComponent(`/services/apexrest/login/verify?email=${payload?.email}&otp=${payload?.otp}`)}`;
  return axiosInstance.request({ url: `${path}`, method: 'get' }).then((res) => res.data);
};

export const postSignupSentOTP = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(`/services/apexrest/portal/send`)}`;
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const postSignup = async (payload: any) => {
  const path = `salesforce?endpoint=${encodeURIComponent(`/services/apexrest/portal/signup`)}`;
  const res = await axiosInstance.post(`${path}`, payload);
  return res && res.data ? res.data : null;
};
